var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bar",style:({ bottom: ((_vm.bar.bottom) + "px") })},_vm._l((_vm.bar.data),function(part){return _c('div',{key:part.label,staticClass:"part-of-bar",class:part.class,style:({
      background: part.color,
      width: ((_vm.bar.width) + "px"),
      height: ((_vm.getHeight(part.value)) + "px")
    })},[(_vm.showValuesOnHover)?_c('LmTooltip',[_c('div',{staticClass:"text-body-3"},[_vm._v(" "+_vm._s(_vm.formatPrice(part.value))+" "),_c('small',[_vm._v(_vm._s(_vm.settings.currency))])])]):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }